var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navBar flex" },
    _vm._l(_vm.listBat, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "cube flex",
          on: {
            click: function ($event) {
              return _vm.cubeClick(item, index)
            },
          },
        },
        [
          _c("div", { staticClass: "circle_one" }, [
            _c("img", { attrs: { src: item.pic } }),
          ]),
          _c("div", [
            _c("span", [_vm._v(_vm._s(item.name))]),
            _c("div", { staticClass: "valueNum" }, [
              _c("span", { staticClass: "num" }, [_vm._v(_vm._s(item.value))]),
              _c("span", { staticClass: "ys" }, [
                _vm._v("(" + _vm._s(item.unit) + ")"),
              ]),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }